<template>
  <div class="prose prose-sm max-w-none break-words" v-html="rendered"></div>
</template>

<script>
import { marked } from "marked";

marked.setOptions({ breaks: true, gfm: true });

// Staff-only internal tool. Strip <script>/<style> and inline event handlers as a
// minimal safeguard since marked does not sanitize by itself.
function sanitize(html) {
  return html
    .replace(/<\/?(script|style|iframe|object|embed)[^>]*>/gi, "")
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "")
    .replace(/javascript:/gi, "");
}

export default {
  name: "MarkdownView",
  props: {
    content: { type: String, default: "" },
  },
  computed: {
    rendered() {
      if (!this.content) return "";
      return sanitize(marked.parse(this.content));
    },
  },
};
</script>
